const handleHTMLContent = (htmlContent) => {
  const splitContent = htmlContent?.split('\n\n');

  const processContent = splitContent?.map(
    (paragraph) => `<div>${paragraph}</div>`
  );

  return processContent?.join('<br />');
};

export default handleHTMLContent;
